import { Fetch } from "./util/InterceptedFetch";
import { BuildUri } from "./util/BuildUri";

import { AttachmentLogRequest, ComplianceRequest } from "../requests/AttachmentLogRequests";
import { MultiPatchRequest } from "../requests/PatchRequests";

import { AttachmentFile } from "../model/Attachment";
import { FileUploadRequest } from "src/requests/CommonRequest";

export class AttachmentLogEndpoints {
    constructor(private fetch: Fetch) {}

    getAttachment(fileId: number): Promise<Blob> {
        return this.fetch(BuildUri("/attachment-log/file/{fileId}", { fileId }), { returnBlob: true });
    }

    addAttachment(attachmentLogId: number, patchRequests: Array<AttachmentLogRequest | FileUploadRequest>): Promise<AttachmentFile> {
        return this.fetch(BuildUri("/attachment-log/{attachmentLogId}", { attachmentLogId }), { method: "PUT", body: patchRequests });
    }

    deleteAttachment(attachmentLogId: number): Promise<AttachmentFile> {
        return this.fetch(BuildUri("/attachment-log/file/{attachmentLogId}", { attachmentLogId }), { method: "DELETE" });
    }

    markLogCompliant(attachmentLogId: number, request: ComplianceRequest): Promise<AttachmentFile> {
        return this.fetch(BuildUri("/attachment-log/{attachmentLogId}/compliance", { attachmentLogId }), { method: "POST", body: request });
    }

    markLogNotCompliant(attachmentLogId: number): Promise<AttachmentFile> {
        return this.fetch(BuildUri("/attachment-log/{attachmentLogId}/compliance", { attachmentLogId }), { method: "DELETE" });
    }
}



// WEBPACK FOOTER //
// ./src/endpoints/AttachmentLogEndpoints.ts